class DailyRitual extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.mediaQuery = window.matchMedia('(min-width: 768px)');
        this.handleBreakpoint = this.handleBreakpoint.bind(this);
    }

    connectedCallback() {
        this.swiperEl = this.querySelector('.daily-ritual-featured-slider');
        if (!this.swiperEl) return;

        this.handleBreakpoint();
        this.mediaQuery.addEventListener('change', this.handleBreakpoint);
    }

    handleBreakpoint() {
        // Desktop (768px+) → Destroy Swiper
        if (this.mediaQuery.matches) {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        } 
        // Mobile (<768px) → Initialize Swiper
        else {
            if (!this.swiper) {
                this.swiper = new Swiper(this.swiperEl, {
                    slidesPerView: 1.4,
                    spaceBetween: 12,
                    observer: true,
                    observeParents: true,
                    watchOverflow: true,
                    breakpoints: {
                        640: {
                            slidesPerView: 2.2,
                        }
                    }
                });
            }
        }
    }

    disconnectedCallback() {
        this.mediaQuery.removeEventListener('change', this.handleBreakpoint);

        if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
        }
    }
}

customElements.define('daily-ritual', DailyRitual);